<ng-container *ngIf="serverError">
  <div class="modal-header">
    <h4 class="modal-title">Server Error: {{ serverError }}</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
</ng-container>

<ng-container *ngIf="!serverError">

  <div class="modal-header">
    <h4 class="modal-title">{{ isNewImage ? 'Add Image' : 'Edit Image' }}</h4>
    <button type="button" class="close" aria-label="Close"
            [disabled]="savingImage"
            [class.disabled]="savingImage"
            (click)="activeModal.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">

    <div class="form-group">
      <label for="carousel_image">
        Image
      </label>
      <form>
        <input id="carousel_image"
               class="mb-2 d-block"
               type="file" accept=".png,.jpg,.jpeg"
               (change)="attachImageFile($event)"
               [disabled]="savingImage"
               [class.disabled]="savingImage">
      </form>
      <img *ngIf="imagePreview"
           [src]="imagePreview"
           class="d-block rounded"
           style="width: 320px; height: 180px; object-fit: cover;"
           alt="Carousel image preview">
      <div *ngIf="!imagePreview"
           class="d-flex justify-content-center align-items-center rounded"
           style="background-color: #d6d6d6; width: 320px; height: 180px;">
        <div>No image selected</div>
      </div>
      <small class="form-text text-muted">
        Recommended 1600 by 900 pixels (16:9). Other shapes are cropped to fit.
      </small>
      <div class="text-danger">
        {{ errors.image }}
      </div>
    </div>

    <div class="form-group">
      <label for="carousel_button_text">Button text</label>
      <input id="carousel_button_text" type="text" class="form-control" name="button_text"
             maxlength="40"
             [(ngModel)]="buttonText"
             [disabled]="savingImage">
      <div class="form-text text-danger">{{ errors.button_text }}</div>
    </div>

    <div class="form-group">
      <label for="carousel_button_gift">Gift</label>
      <select *ngIf="giftableProducts.length > 0 || savedTargetNotGiftable()"
              class="custom-select"
              id="carousel_button_gift"
              name="carousel_button_gift"
              [(ngModel)]="selectedProductKey"
              [disabled]="savingImage">
        <option [ngValue]="null">No button</option>
        <option *ngIf="savedTargetNotGiftable()" [ngValue]="savedTargetKey()">
          {{ image.product_name }} (Not currently giftable)
        </option>
        <ng-container *ngFor="let group of GIFTABLE_PRODUCT_GROUPS">
          <optgroup *ngIf="productsOfType(group.productType).length > 0" [label]="group.label">
            <option *ngFor="let product of productsOfType(group.productType)"
                    [ngValue]="getGiftableProductKey(product)">
              {{ product.name }}
            </option>
          </optgroup>
        </ng-container>
      </select>
      <p *ngIf="giftableProducts.length === 0" class="mb-0">
        No giftable products yet.
        <a routerLink="/gifting-config" (click)="activeModal.dismiss()">Add a gift config</a>
      </p>
      <div class="form-text text-danger">{{ errors.product_type }}</div>
      <div class="form-text text-danger">{{ errors.membership_id }}</div>
      <div class="form-text text-danger">{{ errors.entry_pass_id }}</div>
      <div class="form-text text-danger">{{ errors.voucher_pack_id }}</div>
      <div class="form-text text-danger" *ngIf="buttonIncomplete()">
        Enter button text and choose a gift, or leave both empty.
      </div>
    </div>

    <div class="alert alert-danger" role="alert" *ngIf="errors.non_field_errors">
      {{ errors.non_field_errors }}
    </div>
    <div class="alert alert-danger" role="alert" *ngIf="errorMessage">
      {{ errorMessage }}
    </div>

  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-secondary"
            [disabled]="savingImage"
            [class.disabled]="savingImage"
            (click)="activeModal.close()">
      Cancel
    </button>
    <button type="submit" class="btn btn-primary"
            (click)="saveImage()"
            [disabled]="!canSave()"
            *ngIf="!savingImage">
      Save
    </button>
    <button type="button" class="btn btn-primary disabled" disabled
            *ngIf="savingImage">
      Loading...
    </button>
  </div>

</ng-container>
